// ───────────────────────────────────
// PROJECTS LIST RESPONSE MAPPERS
// ───────────────────────────────────

import { IqeProject } from '../../interfaces/ui';
import { toActivityLogPhase } from './runResults.response.dto';
import { toUiProjectStatus, toTestRuns } from '../sharedDto/status.dto';
import { sortRunsByDateDescending } from '../../utils';

import {
  IqeProjectsApiResponse,
  IqeProjectApiResponseData,
} from '../../interfaces/api/responses/getIqeProjects.response';

// Maps fetched IQE projects API response for given APM number to domain model
export function toIqeProjectsDomain(
  response: IqeProjectsApiResponse,
): IqeProject[] {
  if (!response) {
    return [];
  }

  const projects = response?.data?.projects;

  const toRecentActivityLog = (recentActivityLog: unknown) =>
    Array.isArray(recentActivityLog)
      ? recentActivityLog.map(toActivityLogPhase)
      : [];

  const mapped: IqeProject[] = projects.map(
    (project: IqeProjectApiResponseData) => ({
      id: project.projectId,
      name: project.projectName,
      appUrl: project.appUrl,
      loginNotRequired: project.operation?.startsWith('CREATE_NOLOGIN'),
      environment: project.environment,
      flowId: project.flowId,
      flowName: project.flowName,
      repositoryConfig: project.repositoryConfig,
      frontendRepositoryName: project.frontendRepositoryName,
      frontendRepositoryUrl: project.frontendRepositoryUrl,
      frontendRepositoryBranch: project.frontendRepositoryBranch,
      playwrightTestRepositoryUrl: project.playwrightTestRepositoryUrl,
      projectMappingType:
        project.writeTestPlan?.system?.toLowerCase() === 'qmetry'
          ? 'JIRA'
          : 'ADO',
      transactionId: project.transactionId,
      operation: project.operation,
      status: toUiProjectStatus(project.status),
      testPlanUrl: project.testPlanUrl,
      userEmail: project.userEmail,
      createdAt: new Date(project.createdAt),
      msProjectId: project.msProjectId,
      writeTestPlan: project.writeTestPlan,
      readTestPlan: project.readTestPlan,
      recentActivityLog: toRecentActivityLog(project.recentActivityLog),
      runs: sortRunsByDateDescending((project.runs || []).map(toTestRuns)),
    }),
  );

  return mapped;
}
